import { gate } from 'hub-http/gates';
import isChirpInURL from './isChirpInURL';
import { getGates } from 'quartz-auth/app/service';
const CHIRP_GATE = gate('BuyerExperience:SalesDocumentsCHIRPMigration');

/**
 * Check if CHIRP endpoints should be used.
 * Handles both authenticated and public contexts.
 *
 * Priority:
 * 1. Try getGates().has(CHIRP_GATE) for authenticated apps (documents-ui)
 * 2. Fall back to isChirpInURL() for public apps (documents-public-ui)
 */
export const isChirpEnabled = () => {
  try {
    return getGates().has(CHIRP_GATE);
  } catch (_unused) {
    return isChirpInURL();
  }
};